export const admin = 'admin'
export const voyageadmin = 'voyageadmin'
export const agent = 'agent'
export const approver = 'approver'
export const finance = 'finance'
export const pilot = 'pilot'
export const portcontroller = 'portcontroller'
